<template>
  <v-container class="four-container">
    <v-row>
      <v-col xs="12" align="left" light>
        <p class="title">Page not found</p>
        
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {
  name: 'FourOFour'
}
</script>

<style lang="scss" scoped>
.four-container {
  background-color: white;
  border-radius: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>